var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMother(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.531,
    height: 29.446,
    viewBox: "0 0 28.531 29.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_191204",
    "data-name": "Group 191204",
    transform: "translate(0 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173777",
    "data-name": "Path 173777",
    d: "M29.1,10.127c-.68-.472-1.813-1.258-1.883-2.1C26.844,3.374,23.429,0,19.108,0a8.248,8.248,0,0,0-8.116,8.072c-.04.991-1.466,1.89-2.23,2.373-.618.388-1.316.83-1.082,1.685a1.2,1.2,0,0,0,1.243.863,16.021,16.021,0,0,1,5.184,1.671.011.011,0,0,1,.007,0c.168.077,5.261,2.749,9.527.234.358-.161.724-.322,1.089-.49a19.611,19.611,0,0,1,4.34-1.6,1.252,1.252,0,0,0,1.144-.94c.2-.841-.468-1.3-1.111-1.748m-5.261,2.314c-1.773.8-3.612,1.627-4.734,1.627a13.47,13.47,0,0,1-4.128-1.386,32.177,32.177,0,0,0-3.616-1.422,4.339,4.339,0,0,0,1.791-3.1,6.089,6.089,0,0,1,5.952-6c3.166,0,5.67,2.541,5.955,6.04a4.4,4.4,0,0,0,1.81,2.965c-.98.347-2.014.815-3.031,1.272",
    transform: "translate(-4.842 0)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173778",
    "data-name": "Path 173778",
    d: "M28.531,55.221V56.5H0v-1.28A14.339,14.339,0,0,1,7,42.97a11.123,11.123,0,0,0,2.643,1.514,11.794,11.794,0,0,0-7.012,9.458H25.9A11.762,11.762,0,0,0,18.426,44.3,11.087,11.087,0,0,0,21,42.67a14.322,14.322,0,0,1,7.527,12.551",
    transform: "translate(0 -27.071)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180144",
    "data-name": "Path 180144",
    d: "M24.406,3.108s3.831,6.425,5.864,6.633",
    transform: "translate(-10.14 -1.753)",
    fill: "#f26422",
    stroke: "#f26422",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180145",
    "data-name": "Path 180145",
    d: "M30.27,3.108s-3.831,6.425-5.864,6.633",
    transform: "translate(-16.422 -1.753)",
    fill: "#f26422",
    stroke: "#f26422",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMother);
export default __webpack_public_path__ + "static/media/mother.eb78131f5ff1efaf2780e2f1cd2cd984.svg";
export { ForwardRef as ReactComponent };